import firebase from "firebase/app";
import "firebase/auth";
import config from "server/envConfig";
import "firebase/analytics";

const {
  apiKey,
  authDomain,
  projectId,
  storageBucket,
  messagingSenderId,
  appId,
  measurementId,
} = config.firebase;

const fireBaseConfig = {
  apiKey,
  authDomain,
  projectId,
  storageBucket,
  messagingSenderId,
  appId,
  measurementId,
};

const app = firebase.initializeApp(fireBaseConfig);

export const fireBaseAnalytics = firebase.analytics();

export const auth = app.auth();
export default app;
